import { atomWithQuery } from 'jotai/query';

import { atomWithQuerySubscription } from '@/features/parachain/atomWithQuerySubscription';
import { apiPromiseAtom } from '../parachain/atoms';
import { queryOriginOfShellCollectionId } from '../spirit/queries';

export const canStartIncubationAtom = atomWithQuerySubscription(
  (_, api, subject) => {
    return api.query.pwIncubation.canStartIncubation((result) => subject.next(result.toJSON()))
  },
  false
)

export const originOfShellCollectionIdAtom = atomWithQuery(get => {
  const api = get(apiPromiseAtom)
  return queryOriginOfShellCollectionId(api)
})

export const eraAtom = atomWithQuerySubscription<number>(
  (_, api, subject) => {
    return api.query.pwNftSale.era(result => subject.next(result.toNumber()))
  }
)

export const officialHatchTimeAtom = atomWithQuery(get => {
  const api = get(apiPromiseAtom)
  return {
    queryKey: ['officialHatchTime'],
    queryFn: async () => {
      const officialHatchTime = await api.query.pwIncubation.officialHatchTime()
      return officialHatchTime.toNumber()
    }
  }
})